export const socialsData = {
    github: 'https://github.com/Amirrezagh1991',
    linkedIn: 'https://www.linkedin.com/in/amirrezaghasemi/',
}